import type {
  FarmUserPermissionName,
  FarmUserPermissions,
  RequiredPermissions,
} from "@/constants/permissions"
import type { AnyRequestName } from "./send-request"

interface CheckPermissionArg {
  provided: FarmUserPermissions | null | undefined
  required: RequiredPermissions | null | undefined
}

export interface PermissionDeniedBase {
  code?: string
}
export interface RequestBlockedInDemo extends PermissionDeniedBase {
  code: "REQUEST_BLOCKED_IN_DEMO"
  requestedAction: AnyRequestName
}
export interface MissingPermissions extends PermissionDeniedBase {
  code: "MISSING_PERMISSIONS"
  missingPermissions: FarmUserPermissionName[]
}

export interface PermissionGranted {
  code: "ok"
}

export function checkPermissions({
  provided,
  required,
}: CheckPermissionArg): MissingPermissions | PermissionGranted {
  const requiredArray = Array.isArray(required)
    ? required
    : typeof required === "string"
      ? [required]
      : []
  const missing: FarmUserPermissionName[] = []
  for (const key of requiredArray) {
    let isEnabled = false
    if (provided) {
      isEnabled = provided[key]
    }
    if (!isEnabled) {
      missing.push(key)
    }
  }
  if (missing.length > 0) {
    return { code: "MISSING_PERMISSIONS", missingPermissions: missing }
  }
  return { code: "ok" }
}
